import type { CommentMention } from '../../containers/CommentList/CommentList.types';
import type { HyperlinkMatch } from './useTextParsing';
import {
  discoverMentions,
  findMentionPositions,
  type MentionMatch
} from './mentionParsing';
import { URL_REGEX } from './parsingConstants';
import { extractDomain, isValidUrl, normalizeUrl } from './urlParsing';

export const extractMentions = (
  text: string,
  commentMentions?: CommentMention[]
): MentionMatch[] => {
  if (!text) return [];
  if (commentMentions && commentMentions.length > 0) {
    return findMentionPositions(text, commentMentions);
  }
  return discoverMentions(text).map(mention => ({
    ...mention,
    email: '',
    name: mention.username
  }));
};

export const extractHyperlinks = (text: string): HyperlinkMatch[] => {
  const matches: HyperlinkMatch[] = [];
  const words = text.split(' ');
  let currentIndex = 0;
  URL_REGEX.lastIndex = 0;
  words.forEach((word, wordIndex) => {
    URL_REGEX.lastIndex = 0;
    const match = URL_REGEX.exec(word);
    if (match && match[0] === word) {
      if (isValidUrl(word)) {
        const url = match[0];
        const domain = extractDomain(url);
        matches.push({
          url: normalizeUrl(url),
          domain,
          startIndex: currentIndex,
          endIndex: currentIndex + url.length,
          displayText: domain
        });
      }
    }
    currentIndex += word.length + (wordIndex < words.length - 1 ? 1 : 0);
  });
  return matches;
};
